import { ClearButton } from "./components/clearButton";
import { CompareButton } from "./components/compareButton";
import { Content } from "./components/content";
import { HeaderButton } from "./components/headerButton";
import { Products } from "./components/products";
import { Trigger } from "./components/trigger";
import { Wrapper } from "./components/wrapper";
import { Base } from "./productComparisonBar.base";

const ProductComparisonBarContent = Object.assign(Content, {
    HeaderButton: HeaderButton,
    Products: Products,
    ClearButton: ClearButton,
    CompareButton: CompareButton
});

export const ProductComparisonBar = Object.assign(Base, {
    Trigger: Trigger,
    Wrapper: Wrapper,
    Content: ProductComparisonBarContent
});
